module.exports = __webpack_public_path__ + "img/BG.87edb076.png";